import { useMediaQuery } from '@themenu/design-system'

export const useIsMobile = (): boolean => {
  return useMediaQuery('(max-width: 768px)')
}
